import { render, staticRenderFns } from "./intelligentChat.vue?vue&type=template&id=13fdabf9"
import script from "./intelligentChat.vue?vue&type=script&lang=js"
export * from "./intelligentChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports